import type { StreamType } from "../models/station.js";

/**
 * The `type` field on urls[] is written inconsistently in prod (see docs/data-model.md).
 * V2 normalizes to upper-case at read time and never touches the writer, so
 * legacy readers keep seeing whatever casing was there before.
 *
 * Unknown values are coerced to "WEB" so a bad row never crashes the parser.
 */
export function normalizeStreamType(raw: unknown): StreamType {
  if (typeof raw !== "string") return "WEB";
  const upper = raw.toUpperCase();
  switch (upper) {
    case "HLS":
    case "MP3":
    case "AAC":
    case "WEB":
      return upper;
    default:
      return "WEB";
  }
}
